const jsonParse = (data) => {
  try {
    return JSON.parse(data);
  } catch (ex) {
    return null;
  }
};

export { jsonParse };
